import { ReactNode } from "react";
import CloseIcon from '@mui/icons-material/Close';

const Popup = ({
    title,
    onConfirm,
    onCancel,
    confirmText,
    cancelText,
    content,
    showCancel,
    titleIcon,
    isSub,
    blur,
    footerContent,
    customClass,
    onMouseEnter,
    onMouseLeave,
    noButtons,
    closeIcon
}: {
    title?: string;
    onConfirm?: any;
    onCancel?: any;
    content: ReactNode;
    confirmText?: string;
    cancelText?: string;
    showCancel?: boolean;
    titleIcon?: ReactNode;
    isSub?: boolean;
    blur?: boolean;
    footerContent?: ReactNode;
    customClass?: string;
    onMouseEnter?: any;
    onMouseLeave?: any;
    noButtons?: boolean;
    closeIcon?: boolean;
}) => {

  const handleOutsideClick = () => {
    if(title !== 'DEVICE DISCONNECTED') onCancel();
  }

  return (
    <>
      <div id={isSub ? 'SubPopup' : 'MainPopup'} className={`popup${blur ? " blur" : ""} ${customClass ?? ""}`}>
        {title && <div className="popup-header">
            <h1>{title}</h1>
            <div 
              style={{cursor: onMouseEnter? 'pointer' : 'auto'}} 
              onMouseEnter={onMouseEnter} 
              onMouseLeave={onMouseLeave}
            >
                {titleIcon}
            </div>
        </div>}
        <div className="popup-content">
          {(onMouseEnter || closeIcon) && <CloseIcon className="close-icon" onClick={onCancel} />}
          {content}
          {!noButtons && 
          <div className="button-wrapper">
            <button className="confirm-button" onClick={onConfirm}>{confirmText ?? "OK"}</button>
            {showCancel ? (
              <button onClick={onCancel}>{cancelText ?? "CANCEL"}</button>
            ) : null}
          </div>}
          <div className="popup-footer">
            {footerContent}
          </div>
        </div>
      </div>
      <div className={isSub ? '' : 'overlay'} onClick={handleOutsideClick}></div>
    </>
  );
};

export default Popup;
